import React from 'react'
import PropTypes from 'prop-types'
import SubjectToCSSName from '../../../less/SubjectToCSSName'
import '../typography.css'
import './heading.css'

const defaultHeadingLevels = {
  xs: 5,
  sm: 4,
  md: 3,
  lg: 2,
  xl: 1,
  xxl: 1
}

const SIZE_SCALE: { [size: ?string]: number } = {
  xs: 1,
  sm: 2,
  md: 3,
  lg: 4,
  xl: 5,
  xxl: 6
}

export default function Heading(props) {
  const {
    accessibilityLevel,
    children,
    color = 'darkGray',
    fontWeight = 'normal',
    id = null,
    lgSize,
    mdSize,
    overflow = 'breakWord',
    size = 'md',
    smSize,
    truncate = false,
    align = 'left',
    dangerouslySetInnerHTML,
  } = props

  const cs = [
    'Heading',
    `fontWeight--${fontWeight}`,
    `hFontSize${SIZE_SCALE[size]}`,
    smSize && `smHFontSize${SIZE_SCALE[smSize]}`,
    mdSize && `mdHFontSize${SIZE_SCALE[mdSize]}`,
    lgSize && `lgHFontSize${SIZE_SCALE[lgSize]}`,
    `text-color--${color}`,
    overflow === 'breakWord' && 'breakWord',
    truncate && 'truncate',
    `text-align--${align}`
  ]

  const headingLevel = accessibilityLevel || defaultHeadingLevels[size]
  return React.createElement(
    `h${headingLevel}`,
    {
      className: cs.join(' '),
      id,
      dangerouslySetInnerHTML,
      ...(truncate && typeof children === 'string'
        ? { title: children }
        : null),
    },
    children
  )
}
Heading.propTypes = {
  accessibilityLevel: PropTypes.oneOf([1, 2, 3, 4, 5, 6]),
  children: PropTypes.node,
  color: PropTypes.oneOf([
    'blue',
    'darkGray',
    'midGray',
    'coolGray',
    'lightGray',
    'white',
    'body',
    ...Object.values(SubjectToCSSName).map(color=>`${color}-nav`),
    ...Object.values(SubjectToCSSName).map(color=>`${color}-search`),
    ...Object.values(SubjectToCSSName).map(color=>`${color}-subject`),
    ...Object.values(SubjectToCSSName).map(color=>`${color}-cta`),
  ]),
  fontWeight: PropTypes.oneOf([
    'normal',
    'book',
    'medium',
    'bold'
  ]),
  id: PropTypes.string,
  overflow: PropTypes.oneOf(['normal', 'breakWord']),
  size: PropTypes.oneOf(['xs', 'sm', 'md', 'lg', 'xl', 'xxl']),
  smSize: PropTypes.oneOf(['xs', 'sm', 'md', 'lg', 'xl', 'xxl']),
  mdSize: PropTypes.oneOf(['xs', 'sm', 'md', 'lg', 'xl', 'xxl']),
  lgSize: PropTypes.oneOf(['xs', 'sm', 'md', 'lg', 'xl', 'xxl']),
  truncate: PropTypes.bool,
  align: PropTypes.oneOf([
    'left',
    'right',
    'center',
    'justify'
  ]),
  dangerouslySetInnerHTML: PropTypes.object
}



// WEBPACK FOOTER //
// ./src/core/components/typography/heading/Heading.js